<template>
    <vx-badge class="mr-4" size="xs" :color="item.badge" data-test="campaign-status">
        {{ item.label }}

        <font-awesome-icon v-if="props.icon" :icon="item.icon" class="-mr-1" />
    </vx-badge>
</template>
<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed, type PropType } from 'vue';
import { CAMPAIGN_STATUSES, type CampaignStatus } from '~/constants/campaign';
import { VxBadge } from '@voxie/frontend-components';

const props = defineProps({
    status: {
        type: String as PropType<CampaignStatus>,
        required: true,
    },
    icon: Boolean,
});

const item = computed(() => CAMPAIGN_STATUSES[props.status]);
</script>
